import checkoutRepository from './checkoutRepository';
import { closeTimeoutMS } from '@src/components/layout/modalLayout';

export default class CheckoutModalPresenter {
  async loadModalState(callback) {
    checkoutRepository.load((checkoutPm) => {
      if (checkoutPm.isModalOpen) {
        document.body.classList.add('ReactModal__Body--open-transition');
      } else {
        document.body.classList.remove('ReactModal__Body--open-transition');

        // fix bug when modal is closed faster than closeTimeoutMS value
        setTimeout(() => {
          document.body.classList.remove('ReactModal__Body--open-transition');
          document.body.classList.remove('ReactModal__Body--open');
        }, closeTimeoutMS);
      }

      const checkoutModalVm = {
        isOpen: checkoutPm.isModalOpen,
        modalType: checkoutPm.checkoutType,
      };

      callback(checkoutModalVm);
    });
  }
  closeModal() {
    checkoutRepository.closeModal();
  }
  toggleModal({ type } = {}) {
    checkoutRepository.toggleModal({ type });
  }
}
